export const examStatesAndCities = {
  "Andhra Pradesh": [
    "Kurnool",
    "Rajahmundry",
    "Tirupati",
    "Vijayawada",
    "Visakhapatnam",
  ],
  Bihar: ["Katihar", "Patna", "Gaya"],
  Chhattisgarh: ["Bilaspur CHH", "Raipur"],
  Delhi: ["New Delhi"],
  Gujarat: ["Ahmedabad", "Vadodara", "Rajkot", "Surat"],
  Jharkhand: ["Dhanbad", "Jamshedpur", "Ranchi", "Deoghar"],
  Karnataka: ["Bengaluru", "Ballari", "Bijapur", "Hubballi", "Mysuru"],
  Kerala: ["Kozhikode", "Ernakulam", "Kollam"],
  Maharashtra: [
    "Akola",
    "Aurangabad",
    "Mumbai",
    "Kolhapur",
    "Nagpur",
    "Nashik",
    "Pune",
    "Solapur",
  ],
  "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur"],
  Odisha: ["Bhubaneshwar", "Sambalpur"],
  Punjab: ["Amritsar", "Bhatinda", "Jalandhar", "Ludhiana"],
  Rajasthan: ["Ajmer", "Bhilwara", "Jaipur", "Jodhpur", "Udaipur"],
  "Tamil Nadu": ["Coimbatore", "Chennai", "Madurai", "Salem"],
  Telangana: ["Hyderabad"],
  "West Bengal": [
    "Kolkata",
    "Cooch Behar",
    "Malda",
    "Siliguri",
    "Birbhum Bholpur",
  ],
  Assam: ["Guwahati"],
  "Jammu & Kashmir": ["Jammu", "Srinagar"],
  Chandigarh: ["Chandigarh"],
  Mizoram: ["Aizawl"],
  "Uttar Pradesh": ["Gorakhpur", "Kanpur", "Lucknow", "Varanasi", "Agra"],
  Uttarakhand: ["Dehradun"],
  Tripura: ["Agartala"],
};

export const examLanguages = [
  "English",
  "Hindi",
  "Marathi",
  "Bengali",
  "Gujarati",
  "Assamese",
  "Kannada",
  "Malayalam",
  "Telugu",
  "Tamil",
  "Oriya",
];
